import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import {
  getBulkRolloverRecommendationQuestionnaireTableFilters,
} from 'Overrides/BulkRolloverRecommendationQuestionnaireTable';
import fr from 'facet-rest';
import { FDBox, FDStack, SecondaryActionButton } from '@facet-wealth/design';
import useUserContext from 'Context/UserContext';
import { downloadSecureFileFromLink } from 'Helpers/File';

const style = () => ({
  dialogPaperDesktop: {
    minWidth: 800,
  },
});

const BulkRolloverRecommendationQuestionnairePageContent = ({
  classes,
  rolloverRecommendationQuestionnaireCollection,
  onReset,
  onFailure,
  onSubmit,
}) => {
  const { householdSearch } = useSimpleHousehold();
  const { agentResource } = useUserContext();

  let downloadReportRel = null;
  if (agentResource) {
    downloadReportRel = agentResource.withRelationship(fr.relationships.rolloverRecommendationQuestionnaireReport.name, (rel) => rel, () => null);
  }

  return (
    <FDBox paddingY={1} width={'100%'}>
      <FDStack direction={'column'} width={'100%'} flex={1} spacing={1}>
        { downloadReportRel && <SecondaryActionButton
          label={'Download Report'}
          alignSelf={'flex-end'}
          onClick={async () => { await downloadSecureFileFromLink(downloadReportRel.link('related'), downloadReportRel.meta('title')); }}
        />}
        <MetaTable
          collection={rolloverRecommendationQuestionnaireCollection}
          isPageView
          tableMetaOverrideSetName="BulkRolloverRecommendationQuestionnaireTable"
          hasMetaQueryForm
          columns={[
            { name: 'householdId' },
            { name: 'createdAt' },
            { name: 'feePercentageAtFacet' },
            { name: 'feePercentageAtOtherCustodian' },
            { name: 'feeComparisonDetails' },
            { name: 'attachments' },
          ]}
          QueryFormProps={{
            getAvailableFilters: collection => getBulkRolloverRecommendationQuestionnaireTableFilters(collection, householdSearch),
            onReset,
          }}
          hasSortableColumns
          linkQueryParamName={'getFeatureToggles'}
          features={{
            edit: {
              type: 'dialog',
              metaOverrideSetName: 'BulkRolloverRecommendationQuestionnaireDialog',
              onFailure,
              onSubmit,
              classes: {
                dialogPaper: classes.dialogPaperDesktop,
              },
            },
          }}
        />
      </FDStack>
    </FDBox>
  );
};

BulkRolloverRecommendationQuestionnairePageContent.propTypes = {
  classes: PropTypes.object.isRequired,
  rolloverRecommendationQuestionnaireCollection: PropTypes.array.isRequired,
  onReset: PropTypes.func,
  onFailure: PropTypes.func,
  onSubmit: PropTypes.func,
};

BulkRolloverRecommendationQuestionnairePageContent.defaultProps = {
  onReset: () => false,
  onFailure: () => false,
  onSubmit: () => false,
};

export default withStyles(style)(BulkRolloverRecommendationQuestionnairePageContent);
